import { render } from "./AccountCreate.vue?vue&type=template&id=a33c0d90&scoped=true"
import script from "./AccountCreate.vue?vue&type=script&lang=js"
export * from "./AccountCreate.vue?vue&type=script&lang=js"

import "./AccountCreate.vue?vue&type=style&index=0&id=a33c0d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33c0d90"]])

export default __exports__